import { PREFERENCES_PATH } from '../../constants'
import getCurrentReduxSelector from '../../../redux/selectors/get-current'

const getCurrentPreferencesSelect = getCurrentReduxSelector(PREFERENCES_PATH.DATA,
  PREFERENCES_PATH.CURRENT
)

export default getCurrentPreferencesSelect
